$(function () {
    $('#btnGetQuote[data-get-quote]').each(function () {
        var $btn = $(this);
        var quoteType = $btn.data('getQuote');
        $btn.on('click', function (e) {
            e.preventDefault();

            doFormPost(quoteType);
        });
    });

    $('.timepicker').each((i, el) => {
        const $el = $(el);
        const $dataTip = $el.closest('*[data-tip]');

        if ($dataTip.length) {

            const dataTipTargetId = $dataTip.attr('data-tip-target');
            const $dataTipTarget = dataTipTargetId ? $('#' + dataTipTargetId) : $el;

            if ($dataTipTarget.length) {

                $dataTipTarget.on('focusin mouseover', () => {
                    $dataTip.addClass('show');
                });

                $dataTipTarget.on('focusout mouseout', () => {
                    $dataTip.removeClass('show');
                });

            }
        }
    });
});

function splitAndFormatDate(myDate) {
    var splitDate = myDate.split('/');
    var dateFormatted = splitDate[2] + '-' + splitDate[1] + '-' + splitDate[0];

    return dateFormatted;
}

function generateDateTimeObject(date, time) {
    var splitDate = date.split('/');
    var splitTime = time.split(':');
    return new Date(splitDate[2], Number(splitDate[1]) - 1, splitDate[0], splitTime[0], splitTime[1]);
}

function validateDates(dateFrom, timeFrom, dateTo, timeTo) {
    var dateTimeFrom = generateDateTimeObject(dateFrom, timeFrom);
    var dateTimeTo = generateDateTimeObject(dateTo, timeTo);
    return dateTimeFrom < dateTimeTo;
}

function doFormPost(quoteType) {
    var parkingQuoteUrl = 'https://parking.london-luton.co.uk/search?dateFrom=';
    var bookingQuoteUrl = 'https://booking.london-luton.co.uk/search?dateFrom=';
    var invalidDatesError = $('.parking-ribbon__invalid-dates-error');

    if (window.location.href.indexOf('quba.co.uk') > -1) {
        //parkingQuoteUrl = 'https://lla.testing.airportx.co.uk/search?dateFrom=';
        //bookingQuoteUrl = 'https://booking.lla.testing.airportx.co.uk/search?dateFrom=';
    }

    switch (quoteType) {
        case 'parking': {
            var validDates = validateDates(
                $('#entry-date').val(),
                $('#entry-time').val(),
                $('#leaving-date').val(),
                $('#leaving-time').val()
            );
            if (validDates) {
                window.location.href =
                    parkingQuoteUrl +
                    splitAndFormatDate($('#entry-date').val()) +
                    '&timeFrom=' +
                    $('#entry-time').val() +
                    '&dateTo=' +
                    splitAndFormatDate($('#leaving-date').val()) +
                    '&timeTo=' +
                    $('#leaving-time').val() +
                    '&direction=OUTBOUND&returnTrip=true';
            } else {
                invalidDatesError.show();
            }
            break;
        }
        case 'executive-lounge':
            window.location.href =
                bookingQuoteUrl +
                splitAndFormatDate($('#flight-date').val()) +
                '&timeFrom=' +
                $('#flight-time').val() +
                '&direction=OUTBOUND&returnTrip=false';
            break;
        case 'fast-track':
            window.location.href =
                bookingQuoteUrl +
                splitAndFormatDate($('#departure').val()) +
                '&timeFrom=' +
                $('#flight-time').val() +
                '&direction=OUTBOUND&returnTrip=false';
            break;
    }
}